import { fromJS } from 'immutable';

import * as constants from 'actions/sessions/constants';
import { sessionsUiRecord } from './initialState';

const initialState = sessionsUiRecord();

export default (state = initialState, action) => {
  switch (action.type) {
    case constants.GET_ACTIVE_SESSIONS:
      return state.setIn(['active', 'loader'], true);

    case constants.GET_ACTIVE_SESSIONS_SUCCESS:
      return state
        .setIn(['active', 'loader'], false)
        .setIn(['active', 'error'], null);

    case constants.GET_ACTIVE_SESSIONS_ERROR:
      return state
        .setIn(['active', 'loader'], false)
        .setIn(['active', 'error'], fromJS(action.error));

    case constants.GET_HISTORICAL_SESSIONS:
      return state.setIn(['historical', 'loader'], true);

    case constants.GET_HISTORICAL_SESSIONS_SUCCESS:
      return state
        .setIn(['historical', 'loader'], false)
        .setIn(['historical', 'error'], null);

    case constants.GET_HISTORICAL_SESSIONS_ERROR:
      return state
        .setIn(['historical', 'loader'], false)
        .setIn(['historical', 'error'], fromJS(action.error));

    default:
      return state;
  }
};
